export const insightBlurClass =
  'select-none blur-sm pointer-events-none' as const;
